import React from 'react'

import ReferralESignatureConsentPdf from '@/components/misc/ReferralESignatureConsentPdf/ReferralESignatureConsentPdf'
import { ESIGNATURE_TAB_KEY } from '@/components/misc/ReferralESignatureConsentPdfPreview/constants'
import { useESignaturePreviewTab } from '@/components/misc/ReferralESignatureConsentPdfPreview/hooks/useESignaturePreviewTab'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { cn } from '@/lib/utils'

type Props = React.ComponentProps<typeof ReferralESignatureConsentPdf> & {
  consentFiles: Array<{
    originalFileName: string
    fileUrl: string
  }>
}

interface TabDetail {
  key: string
  title: string
  content: React.ReactNode
}

const ReferralESignatureConsentPdfPreview: React.FC<Props> = ({
  consentFiles,
  ...props
}) => {
  const [tab, setTab] = useESignaturePreviewTab()

  const tabs: TabDetail[] = [
    {
      key: ESIGNATURE_TAB_KEY,
      title: 'eSignature',
      content: <ReferralESignatureConsentPdf {...props} />,
    },
  ]

  if (consentFiles.length > 0) {
    consentFiles.forEach((consentFile, index) => {
      tabs.push({
        key: (index + 2).toString(),
        title: consentFile.originalFileName,
        content: (
          <iframe
            src={consentFile.fileUrl}
            width="100%"
            className="mb-4 border"
            style={{ height: '302mm' }}
          />
        ),
      })
    })
  }

  if (tabs.length === 1) {
    // No point tabbing if there's only one thing to show
    return tabs[0]?.content
  }

  return (
    <Tabs
      className="mx-auto mt-2"
      value={tab}
      onValueChange={(tab) => {
        setTab(tab)
      }}
    >
      <TabsList className={cn({ hidden: tabs.length === 1 })}>
        {tabs.map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key}>
            {tab.title}
          </TabsTrigger>
        ))}
      </TabsList>

      {tabs.map((tab) => (
        <TabsContent key={tab.key} value={tab.key}>
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  )
}

export default ReferralESignatureConsentPdfPreview
